import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import ContentPageList from '../../../components/SiteAdmin/ContentPage/ContentPageList';
import Loader from '../../../components/Common/Loader/Loader';
import messages from '../../../locale/messages';
import getContentPageDetails from './getContentPageDetails.graphql';
import useQueryResponse from '../../../lib/hooks/useQueryResponse';

const ContentPage = ({ currentPage }) => {

  const { loading, data, refetch } = useQueryResponse({
    query: getContentPageDetails,
    variables: { currentPage },
    fetchPolicy: 'network-only',
  });

  const contentPages = data?.getContentPageDetails || [];

  return (
    <Loader type="page" show={loading}>
      <h1 className='siteAdminPrimaryHeading'><FormattedMessage {...messages.contentpageManagement} /></h1>
      {!loading && <ContentPageList data={contentPages} refetch={refetch} />}
    </Loader>
  );
};

ContentPage.propTypes = {
  currentPage: PropTypes.number
};

export default ContentPage;
